import React, { useState } from "react";
import axios from "axios";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";

import JONDdDialog from "./JONDdDialog";
import { FormattedDate } from "../../../helpers/TemplateHelper";

const JONDdTable = ({
  jonList,
  onChange,
  toastrRef,
  orderStatus,
  latestReferenceNo,
}) => {
  const [dialogVisible, setDialogVisible] = useState(false);
  const [selectedJON, setSelectedJON] = useState(null);

  const actionTemplate = (rowData) => {
    if (orderStatus === 1) {
      return (
        <div>
          <Button
            icon="pi pi-pencil"
            className="p-button-rounded p-button-info mr-2"
            onClick={() => {
              setSelectedJON(rowData);
              setDialogVisible(true);
            }}
          />
        </div>
      );
    } else {
      return null;
    }
  };

  return (
    <div>
      <div className="pt-8">
        <h5 className="text-color-secondary">Job Order</h5>
        <DataTable
          value={jonList}
          tableStyle={{ minWidth: "900px" }}
          className="p-datatable-striped"
        >
          <Column style={{ width: "100px" }} header="" body={actionTemplate} />
          <Column header="Bill No" body={() => latestReferenceNo} />
          <Column field="jobOrderNo" header="Job Order No" sortable />
          <Column
            field="deliveryDate"
            header="Delivery Date"
            sortable
            body={(row) =>
              row?.deliveryDate ? <FormattedDate date={row.deliveryDate} /> : ""
            }
          />
          <Column
            style={{ width: "150px" }}
            field="updated"
            header="Updated"
            sortable
            body={(row) =>
              row?.updated ? <FormattedDate date={row.updated} /> : ""
            }
          />
        </DataTable>

        <JONDdDialog
          visible={dialogVisible}
          onCancel={() => setDialogVisible(false)}
          orderId={selectedJON?.id}
          jonData={selectedJON}
          toastrRef={toastrRef}
          onOrderAccepted={() => {
            setDialogVisible(false);
            onChange();
          }}
          latestReferenceNo={latestReferenceNo || ""}
          isEdit={true}
        />
      </div>
    </div>
  );
};

export default JONDdTable;
